import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription, interval } from 'rxjs';
import { ChartService } from 'src/app/services/chart.service';
import { DataService } from 'src/app/services/data.service';
import { takeUntil } from 'rxjs/operators';
import { ChartObject } from 'highcharts';

@Component({
  selector: 'app-is',
  templateUrl: './is.component.html',
  styleUrls: ['./is.component.scss']
})
export class IsDetailComponent implements OnInit, OnDestroy {
  
  private destroy$: Subject<void>;
  private sub: Subscription;

  private isSub: Subscription;

  private isChart: ChartObject;

  constructor(public chartService: ChartService, public dataService: DataService) {
    this.destroy$ = new Subject();
  }

  ngOnInit() {

    this.sub = this.dataService.status$.subscribe(value => {

      if (value === 'not-started') return;

      this.isSub = this.chartService.icuCharts.is.rr.chart.ref$.subscribe(chart => {
        this.isChart = chart;
        this.isChart.redraw();
      });

      if (value === 'started') {
        this.redrawInterval();
      }
      if (value === 'stopped') {
        this.destroy$.next();
      }

    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.sub.unsubscribe();
    
    if (this.isSub) this.isSub.unsubscribe();
  }

  redrawInterval() {
    interval(1000).pipe(takeUntil(this.destroy$)).subscribe(() => this.redrawCharts());
  }

  redrawCharts() {
    if (this.isChart) this.isChart.redraw();
  }

}
